import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Hero = () => {
  const { t } = useLanguage();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-[#0B1321]">
      {/* wallpaper — fills the whole hero */}
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none bg-cover bg-center"
        style={{ backgroundImage: "url('/hero-wallpaper.jpg')" }}
      />

      {/* fade: ~99% opaque behind the text (left) fading to fully visible art (center → right) */}
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'linear-gradient(90deg, rgba(11,19,33,0.99) 0%, rgba(11,19,33,0.99) 32%, rgba(11,19,33,0.85) 42%, rgba(11,19,33,0.35) 52%, rgba(11,19,33,0) 62%)',
        }}
      />

      {/* subtle grain via svg overlay pattern */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            'radial-gradient(rgba(255,255,255,0.4) 1px, transparent 1px)',
          backgroundSize: '3px 3px',
        }}
      />

      <div className="relative max-w-6xl w-full mx-auto px-6 lg:px-10 fade-up">
        <div className="max-w-xl md:max-w-2xl text-left">
          <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.2] tracking-normal pb-2">
            <span className="gold-text block pb-1">{t.hero.title1}</span>
            <span className="light-text block mt-2 pb-2">{t.hero.title2}</span>
          </h1>

          <p className="mt-8 max-w-xl text-base md:text-lg text-[#B7BDCC] font-light leading-relaxed">
            {t.hero.subtitle}
          </p>

          <div className="mt-12 flex flex-col sm:flex-row items-start justify-start gap-4">
            <button
              onClick={() => scrollTo('bridge')}
              className="gold-btn px-8 py-4 text-xs tracking-[0.25em] font-semibold rounded-md min-w-[220px]"
            >
              {t.hero.primary}
            </button>
            <button
              onClick={() => scrollTo('about')}
              className="outline-btn px-8 py-4 text-xs tracking-[0.25em] font-semibold rounded-md min-w-[220px]"
            >
              {t.hero.secondary}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
